import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DetectorBoardsComponent } from './detector-boards/detector-boards.component';

const routes: Routes = [
  {
    path: '',
    component: DetectorBoardsComponent,
    data: {
      title: 'Sensor Board',
      urls: [{ title: 'Dashboard', url: '/' }, { title: 'Sensor Board' }],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DetectorBoardRoutingModule {}
